export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:error', (e) => {
    console.error(e)
  })
})
